import { render, staticRenderFns } from "./ConfigsEdit.vue?vue&type=template&id=dc9d776c&scoped=true&"
import script from "./ConfigsEdit.vue?vue&type=script&lang=ts&"
export * from "./ConfigsEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigsEdit.vue?vue&type=style&index=0&id=dc9d776c&lang=scss&scoped=true&"
import style1 from "./ConfigsEdit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9d776c",
  null
  
)

export default component.exports